import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import ResumeBar from "./ResumeBar";
import MobileDrawer from "./MobileDrawer";
import SearchOverlay from "../search/SearchOverlay";
import LightboxHost from "../shared/LightboxHost";

export default function Layout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <div
      data-testid="app-shell"
      className="flex min-h-screen flex-col bg-[#FAF7F2] text-[#1A1A1A]"
    >
      <ResumeBar />
      <Header
        onOpenSearch={() => setSearchOpen(true)}
        onOpenMenu={() => setDrawerOpen(true)}
      />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <BottomNav />
      <MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
      <SearchOverlay open={searchOpen} onOpenChange={setSearchOpen} />
      <LightboxHost />
    </div>
  );
}
